export enum UserRole {
  ADMIN = 'admin',
  EDITOR = 'editor',
  REVIEWER = 'reviewer',
  AUTHOR = 'author',
  USER = 'user'
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export interface User {
  id: string;
  lastName: string;
  firstName: string;
  middleName?: string;
  email: string;
  /** Основная роль (для совместимости): admin > editor > reviewer > author > user */
  role: UserRole;
  /** Все роли пользователя */
  roles?: UserRole[];
  status: UserStatus;
  createdAt: string;
  updatedAt: string;
  articles?: string[];
}

const ROLE_PRIORITY: UserRole[] = [
  UserRole.ADMIN,
  UserRole.EDITOR,
  UserRole.REVIEWER,
  UserRole.AUTHOR,
  UserRole.USER,
];

export function getUserRoles(user: Pick<User, 'role' | 'roles'> | null | undefined): UserRole[] {
  if (!user) return [];
  if (Array.isArray(user.roles) && user.roles.length > 0) {
    return [...new Set(user.roles)];
  }
  return user.role ? [user.role] : [];
}

export function hasRole(
  user: Pick<User, 'role' | 'roles'> | null | undefined,
  role: UserRole | string
): boolean {
  return getUserRoles(user).includes(role as UserRole);
}

export function hasAnyRole(
  user: Pick<User, 'role' | 'roles'> | null | undefined,
  roles: Array<UserRole | string>
): boolean {
  const userRoles = getUserRoles(user);
  return roles.some((role) => userRoles.includes(role as UserRole));
}

export function getPrimaryRole(roles: UserRole[]): UserRole {
  for (const role of ROLE_PRIORITY) {
    if (roles.includes(role)) return role;
  }
  return UserRole.USER;
}

export function getUserFullName(user: User): string {
  return `${user.lastName} ${user.firstName}${user.middleName ? ` ${user.middleName}` : ''}`;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Администратор',
  [UserRole.EDITOR]: 'Редактор',
  [UserRole.REVIEWER]: 'Рецензент',
  [UserRole.AUTHOR]: 'Автор',
  [UserRole.USER]: 'Пользователь',
};
